import {
    useEffect, useState, useCallback, useRef,
} from 'react';
import trimTags from 'components/helpers/trimTags';
import {getSelectionRange} from 'components/controls/RichEditor/utils/getSelectionRange';
import {getSelectionCoordinates} from 'components/controls/RichEditor/utils/getSelectionCoordinates';


const getNewMacro = (target) => {
    const {selectionStart} = target;
    const value = target.value.value || target.value;
    const escapedValue = trimTags(value);
    const words = escapedValue.slice(0, selectionStart).split(' ');
    const lastWord = words[words.length - 1];
    if (lastWord.indexOf('#') === -1) {
        return '';
    }
    const macros = lastWord.split('#');
    return macros[macros.length - 1];
};

const initialState = {
    macro: '',
    macroDropDownPosition: {
        top: 0,
        left: 0,
    },
};

export function useMacros(editorState) {
    const [
        {
            macro,
            macroDropDownPosition,
        },
        setState,
    ] = useState(initialState);

    const clearState = () => setState(initialState);

    const containerRef = useRef(null);

    const calcCaretPosition = () => {
        const range = getSelectionRange();

        if (!range) {
            return;
        }
        const isMobileiOS = /webkit.*mobile/i.test(navigator.userAgent);
        const {top, left} = getSelectionCoordinates(containerRef.current, range);

        // Because keyboard on ios dispose top coordinates
        return {top: isMobileiOS ? window.pageYOffset + top : top, left};
    };

    const handleUpdateMacro = useCallback((e, clearState) => {
        if (clearState) {
            setState({
                macro: '',
                macroDropDownPosition: {left: 0, top: 0},
            });

            return;
        }

        const {target} = e;
        const newMacro = getNewMacro(target);
        const newMacroDropDownPosition = newMacro === macro
            ? macroDropDownPosition
            : calcCaretPosition();


        setState({
            macro: newMacro,
            macroDropDownPosition: newMacroDropDownPosition,
        });
    }, [macro, macroDropDownPosition]);

    useEffect(() => {
        const selection = editorState.getSelection();
        const anchorKey = selection.getAnchorKey();
        const content = editorState.getCurrentContent();
        const block = content.getBlockForKey(anchorKey);
        const start = selection.getStartOffset();
        const value = block.getText();

        handleUpdateMacro({target: {value, selectionStart: start}});
    }, [editorState]);

    return [
        {
            macro,
            macroDropDownPosition,
        },
        handleUpdateMacro,
        containerRef,
        clearState,
    ];
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useMacros.js